import { IMAGE_URL } from "./api";
import { getAccessToken } from "./auth";

export { IMAGE_URL };

export function toProtectedMediaPath(path) {
  if (!path) return null;
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (normalized.startsWith("/media/")) {
    return normalized.replace("/media/", "/protected-media/");
  }
  return normalized;
}

export async function fetchProtectedImage(path) {
  const protectedPath = toProtectedMediaPath(path);
  if (!protectedPath) return null;

  if (protectedPath.startsWith("http")) {
    return protectedPath;
  }

  const token = getAccessToken();
  if (!token) return null;

  const response = await fetch(`${IMAGE_URL}${protectedPath}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error("Failed to load image");
  }

  const blob = await response.blob();
  return URL.createObjectURL(blob);
}
